import { render, staticRenderFns } from "./product-drainage-system.vue?vue&type=template&id=355a98ac&scoped=true&"
import script from "./product-drainage-system.vue?vue&type=script&lang=js&"
export * from "./product-drainage-system.vue?vue&type=script&lang=js&"
import style0 from "./product-drainage-system.vue?vue&type=style&index=0&id=355a98ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a98ac",
  null
  
)

export default component.exports